export const getIsImraUser = (hasFeature) =>
  hasFeature('has_texas_ela_license');
